export default __webpack_public_path__ + "static/Compliance-&-support-11ef686696599eb1015ed621419a5d16.webp";